import { render, staticRenderFns } from "./BottomMenu.vue?vue&type=template&id=0ad210a2&scoped=true"
import script from "./BottomMenu.vue?vue&type=script&lang=js"
export * from "./BottomMenu.vue?vue&type=script&lang=js"
import style0 from "./BottomMenu.vue?vue&type=style&index=0&id=0ad210a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad210a2",
  null
  
)

export default component.exports